import store from '../store'
import {getToken} from '@/utils/auth' // 验权
if (getToken()) {
  store.dispatch('updateAfterSaleCount', { resolve: 'N'})
  store.dispatch('updateRequireNumCount', { handleStatus: 0})
}



// WEBPACK FOOTER //
// ./src/plugins/initCountData.js